var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgFan = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 0C3.79086 0 2 1.79086 2 4C2 5.19469 2.52375 6.26706 3.35418 7H0V9C0 11.2091 1.79086 13 4 13C5.19469 13 6.26706 12.4762 7 11.6458V15L9 15C11.2091 15 13 13.2091 13 11C13 9.80531 12.4762 8.73294 11.6458 8H15V6C15 3.79086 13.2091 2 11 2C9.80531 2 8.73294 2.52375 8 3.35418V0H6ZM4 4C4 2.89543 4.89543 2 6 2V6C4.89543 6 4 5.10457 4 4ZM11 4C12.1046 4 13 4.89543 13 6L9 6C9 4.89543 9.89543 4 11 4ZM9 13C10.1046 13 11 12.1046 11 11C11 9.89543 10.1046 9 9 9L9 13ZM4 11C2.89543 11 2 10.1046 2 9H6C6 10.1046 5.10457 11 4 11Z",
    fill: "#595959"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFan, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/fan.326feee2.svg";
export { ForwardRef as ReactComponent };